export default {"src":"/_next/static/media/enisa-logo.b2a3732b.svg","height":101,"width":108,"blurWidth":0,"blurHeight":0};